// extracted by mini-css-extract-plugin
var _1 = "CarouselThumbnailDragPreview-module__previewContainer--f0Z70";
export { _1 as "previewContainer" }
